import { render } from "./AdminLogsEdit.vue?vue&type=template&id=f6addfba"
import script from "./AdminLogsEdit.vue?vue&type=script&lang=js"
export * from "./AdminLogsEdit.vue?vue&type=script&lang=js"

import "./AdminLogsEdit.vue?vue&type=style&index=0&id=f6addfba&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__